module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1043-7e63b934f341abc8ab0ef064f6249b34.png";